import { CollapseIcon, ExpanderIcon } from 'components/Elements/Icons';
import { useState } from 'react';

import Styles from './index.module.scss';

interface Props {
	children?: React.ReactNode;
	containerRef?: React.RefObject<HTMLDivElement>;
}

export const Expander = ({ children, containerRef: ref }: Props) => {
	const [isExpanded, setIsExpanded] = useState(true);
	return (
		<nav className={`${Styles.container} ${!isExpanded ? Styles.collapsed : ''}`} ref={ref}>
			{children}
			<div className={`${Styles.expander} ${!isExpanded && Styles.collapsed}`}>
				{isExpanded && (
					<ExpanderIcon
						onClick={() => {
							setIsExpanded((state) => !state);
						}}
					/>
				)}
				{!isExpanded && (
					<CollapseIcon
						onClick={() => {
							setIsExpanded((state) => !state);
						}}
					/>
				)}
			</div>
		</nav>
	);
};
